<template>
  <div class="header-box">
    <img src="../assets/img/logo.png"
         alt=""
         class="logo-box">
    <div class="header-cont">研究生录取邮递地址管理平台</div>
    <div class="btn-box"
         @click="goOut">退出</div>
  </div>
</template>
<script>
export default {
  name: 'headerNav',
  methods: {
    goOut () {
      this.$axios.get('/api/login/logout').then(res => {
        if (res.data.code == 10000) {
          this.$router.push('/')
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.header-box {
  width: 100%;
  height: 80px;
  padding: 0 10%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: $blue;
  .logo-box {
    width: 350px;
  }
  .header-cont {
    color: #fff;
    font-size: 18px;
  }
  .btn-box {
    color: #fff;
    font-size: 12px;
    cursor: pointer;
  }
}
</style>